import { Injectable } from '@angular/core'
import { StorageService } from './storage.service'

@Injectable()
export class CIDService {
  private storageKey = 'cID'

  constructor(private storageService: StorageService) {}

  ensureCIDExists(): void {
    if (!this.storageService.load(this.storageKey)) {
      const cID = this.generateCId()
      this.storageService.save(this.storageKey, cID)
    }
  }

  getCID(): string {
    const sid = this.storageService.load<string>(this.storageKey)
    return sid
  }

  private generateCId(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      // @ts-ignore
      // tslint:disable-next-line:no-bitwise
      const r = (Math.random() * 16) | 0
      // tslint:disable-next-line:no-bitwise
      const v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }
}
